import React, { Component, PropTypes } from 'react';
import _ from 'underscore';

class ContactForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            name: props.profile.profile.full_name || '',
            email: props.profile.email || '',
            telephone: '',
            branch: '',
            message: '',
            postcode: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const { name, email, message, postcode } = this.state;

        if (!_.isNull(name) && !_.isNull(email) && !_.isNull(message) && !_.isNull(postcode)) {
            this.props.handleSubmit(this.state);
        }
    };

    render() {
        return (
            <form className="contact-form" onSubmit={this.handleSubmit}>
                <div className="field">
                    <input
                        type="text"
                        name="name"
                        placeholder="Your name"
                        value={this.state.name}
                        onChange={e => this.setState({ name: e.target.value })} />
                </div>
                <div className="field">
                    <input
                        type="email"
                        name="email"
                        placeholder="Your e-mail address"
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })} />
                </div>
                <div className="field">
                    <input
                        type="text"
                        name="telephone"
                        placeholder="Your phone number"
                        value={this.state.telephone}
                        onChange={e => this.setState({ telephone: e.target.value })} />
                </div>
                <div className="field">
                    <input
                        type="text"
                        name="postcode"
                        placeholder="Your postcode"
                        value={this.state.postcode}
                        onChange={e => this.setState({ postcode: e.target.value })} />
                </div>
                {/* <div className="field">
                    <select name="branch">
                        <option value="daventry">Daventry</option>
                        <option value="coventry">Coventry</option>
                        <option value="birmingham">Birmingham</option>
                        <option value="Other">Other</option>
                    </select>
                </div>*/ }
                <div className="field">
                    <textarea
                        name="message"
                        cols="10"
                        rows="10"
                        placeholder="Your message"
                        value={this.state.message}
                        onChange={e => this.setState({ message: e.target.value })} />
                </div>
                <input type="submit" value="Send Message" className="submit" />
            </form>
        );
    }
}

ContactForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    profile: PropTypes.object
};

module.exports = ContactForm;



/** WEBPACK FOOTER **
 ** ./src/forms/BookSessionForm.js
 **/